import { useStatements } from '@/modules/projects/hooks/project'
import type { Statement } from '@/modules/projects/stores/types'
import type { PortfolioAccount } from '../types'
import { foldSecuritiesAccounts } from '../useProjectSecurities'

const accountsByStatements = new WeakMap<Statement[], PortfolioAccount[]>()

// The store hands back the same statements array until the data changes, so it keys the fold.
export const detailAccountsFor = (
  statements: Statement[],
): PortfolioAccount[] => {
  const cached = accountsByStatements.get(statements)
  if (cached) return cached
  const accounts = foldSecuritiesAccounts(statements)
  accountsByStatements.set(statements, accounts)
  return accounts
}

export const useDetailAccounts = (): PortfolioAccount[] =>
  detailAccountsFor(useStatements())
